// import { StorefrontPlugins } from "@engyalo/storefront-types";
// import { Grid } from "@chakra-ui/core";
// import { CustomProduct } from "./plugins/CustomProduct";
// import { CustomProductFooter } from "./plugins/CustomProductFooter";
// import { HorizontalProduct } from "./plugins/HorizontalProduct";
// import { CustomCartItem } from "./plugins/CustomCartItem";

// export const plugins = {
//   Catalogue: {
//     container: Grid,
//     props: {
//       gridTemplateColumns: "1fr",
//       gridRowGap: "0",
//     },
//   },
//   CollectionProduct: {
//     container: HorizontalProduct,
//   },
//   ProductDetailBody: {
//     container: CustomProduct,
//   },
//   ProductAddToCart: {
//     container: CustomProductFooter,
//   },
//   CartItemDetail: {
//     container: CustomCartItem,
//   },
// } as StorefrontPlugins;

import { StorefrontPlugins } from '@engyalo/storefront-types';
import { VerticalCard } from './plugins/VerticalCard';
import { Grid } from '@chakra-ui/core';
export const plugins = {
  Catalogue: {
    container: Grid,
    props: {
      gridTemplateColumns: '1fr',
    },
  },
  CollectionProduct: {
    container: VerticalCard,
  },
} as StorefrontPlugins;
